module.exports = __webpack_public_path__ + "static/media/IconExamSetCurriculumAddMargin.1d7cfaf0.svg";